import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { MetaPage, Option } from 'interfaces';
import {
  Country,
  CustomMailRecipientResponse,
  CustomMailSendingPayload,
  CustomMailSent,
  CustomMailSentListState,
  CustomMailState,
  CustomMailTemplate,
  CustomMailTemplateState,
} from 'interfaces/custom-mail';

import {
  customMailSending,
  getCountryList,
  getCustomMailEntityMembers,
  getCustomMailSent,
  getCustomMailTemplate,
  getCustomMailUsers,
  getEntities,
  getMailTypes,
} from './action';

export function getCustomMailTypesReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(getMailTypes.fulfilled, (state, action: PayloadAction<Option[]>) => {
    state.types.isLoading = false;
    state.types.options = action.payload;
  });

  builder.addCase(getMailTypes.pending, (state) => {
    state.types.isLoading = true;
  });

  builder.addCase(getMailTypes.rejected, (state) => {
    state.types.isLoading = false;
  });
}

export function getEntitiesReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(getEntities.fulfilled, (state, action: PayloadAction<Option[]>) => {
    state.entities.isLoading = false;
    state.entities.options = action.payload;
  });

  builder.addCase(getEntities.pending, (state) => {
    state.entities.isLoading = true;
  });

  builder.addCase(getEntities.rejected, (state) => {
    state.entities.isLoading = false;
  });
}

export function getCustomMailTemplateReducer(builder: ActionReducerMapBuilder<CustomMailTemplateState>) {
  builder.addCase(getCustomMailTemplate.fulfilled, (state, action: PayloadAction<CustomMailTemplate>) => {
    state.isLoading = false;
    state.template = action.payload;
  });

  builder.addCase(getCustomMailTemplate.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getCustomMailTemplate.rejected, (state) => {
    state.isLoading = false;
  });
}

export function getCustomMailRecipientsReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(getCustomMailEntityMembers.pending, (state) => {
    state.entityMembersList.isLoading = true;
  });

  builder.addCase(getCustomMailEntityMembers.fulfilled, (state, action: PayloadAction<CustomMailRecipientResponse>) => {
    state.entityMembersList.isLoading = false;

    state.entityMembersList.list = action.payload.data;
  });

  builder.addCase(getCustomMailEntityMembers.rejected, (state) => {
    state.entityMembersList.isLoading = false;
  });
}

export function getCustomMailUsersReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(getCustomMailUsers.pending, (state) => {
    state.usersList.isLoading = true;
  });

  builder.addCase(getCustomMailUsers.fulfilled, (state, action: PayloadAction<CustomMailRecipientResponse>) => {
    state.usersList.isLoading = false;

    state.usersList.list = action.payload.data;
  });

  builder.addCase(getCustomMailUsers.rejected, (state) => {
    state.usersList.isLoading = false;
  });
}

export function customMailSendingReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(customMailSending.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(customMailSending.fulfilled, (state, action: PayloadAction<{ data: CustomMailSendingPayload }>) => {
    state.mailSend = action.payload.data;
    state.isLoading = false;
  });

  builder.addCase(customMailSending.rejected, (state) => {
    state.isLoading = false;
  });
}

export function getCountriesReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(getCountryList.fulfilled, (state, action: PayloadAction<Country[]>) => {
    state.countryList.isLoading = false;
    state.countryList.list = action.payload;
  });

  builder.addCase(getCountryList.pending, (state) => {
    state.countryList.isLoading = true;
  });

  builder.addCase(getCountryList.rejected, (state) => {
    state.countryList.isLoading = false;
  });
}

export function getCustomMailSentReducer(builder: ActionReducerMapBuilder<CustomMailState>) {
  builder.addCase(getCustomMailSent.pending, (state) => {
    state.sentList.isLoading = true;
  });

  builder.addCase(
    getCustomMailSent.fulfilled,
    (state, action: PayloadAction<{ data: CustomMailSent[]; meta: MetaPage }>) => {
      state.sentList.isLoading = false;

      state.sentList.list = action.payload.data;
      state.sentList.total = action.payload.meta.total;
      state.sentList.totalPages = action.payload.meta.last_page;
    },
  );

  builder.addCase(getCustomMailSent.rejected, (state) => {
    state.entityMembersList.isLoading = false;
  });
}
